'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.attachHandlerToButtonClick = attachHandlerToButtonClick;
exports.hasIntegration = hasIntegration;
exports.getValueForIntegration = getValueForIntegration;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _immutabilityHelper = require('immutability-helper');

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _tree = require('./tree');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DEFAULT = exports.DEFAULT = 'default';

function attachHandlerToButtonClick(config, functionName, handler) {
  if (_lodash2.default.isEmpty(config)) {
    return config;
  }

  var newConfig = _extends({}, config);

  var configKeys = _lodash2.default.keys(config.data);

  _lodash2.default.forEach(configKeys, function (configKey) {
    var tree = _lodash2.default.get(config, 'data.' + configKey + '.tree');

    var processedTree = _extends({}, tree);

    var buttons = (0, _tree.findAllNodesOfTagInTree)(tree, 'button');

    _lodash2.default.forEach(buttons, function (button) {
      if (_lodash2.default.get(button, 'p._function') === functionName) {
        processedTree = (0, _tree.setPropOnNodeInTree)(processedTree, button.path, 'onClick', handler);
        processedTree = (0, _tree.removePropFromNodeInTree)(processedTree, button.path, '_function');
      }
    });

    newConfig = (0, _immutabilityHelper2.default)(newConfig, {
      data: _defineProperty({}, configKey, {
        tree: {
          $set: processedTree
        }
      })
    });
  });

  return newConfig;
}

function hasIntegration(config, integration) {
  return _lodash2.default.has(config, 'data.default.integrations.' + integration);
}

function getValueForIntegration(config, integration, key) {
  if (!hasIntegration(config, integration)) {
    return undefined;
  }

  var s = _lodash2.default.get(config, 'data.default.integrations.' + integration);

  var v = _lodash2.default.find(s, ['key', key]);

  if (_lodash2.default.has(v, 'value')) {
    return v.value;
  }

  return undefined;
}